import { Box } from "@mui/material";
import { formatAMPM } from "../../../../../constants";
import moment from "moment";
import { LanguageContext } from "../../../../../context/LanguageContext";
import { formatNum } from "../../../../../oscar-pos-core/constants";
import withObservables from "@nozbe/with-observables";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { ParagraphText } from "../../../../../Libraries";
import { INVOICE_SCHEMA, PAYMENT_SCHEMA } from "../../../../../database/schema";

const StockHistoryTableRow = ({ item, product, key }) => {
  const {
    is_secondary_unit,
    unit_conversion,
    transacted_at,
    tran_type,
    quantity,
    payment,
    invoice,
    txns,
    type,
    table_name,
    refrence_id
  } = item || {};
  const [I18n] = useContext(LanguageContext);
  const [profit, setProft] = useState(0);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    if (item) {
      setProft(calculateProfit());
      setPrice(calculatePrice());
    }
  }, [item]);

  const calculatePrice = () => {
    let itemPrice =
      type == "sales"
        ? item?.selling_price || 0
        : item.type == "expense"
          ? item?.cost_price || 0
          : item?.price || item?.selling_price;
    let itemDiscountMethod = item?.discount_method || "rs";
    let itemDiscount = item?.discount || 0;

    if (itemDiscountMethod == "%") {
      let discount = (itemDiscount / 100) * itemPrice;
      return formatNum((itemPrice - discount) * item.quantity);
    } else {
      return formatNum((itemPrice - itemDiscount) * item.quantity);
    }
  };

  const calculateProfit = () => {
    if (item.type == "sales") {
      let price = (item?.selling_price || 0) - (item?.cost_price || 0);
      let itemPrice = item?.selling_price || 0;
      let itemDiscountMethod = item?.discount_method || "rs";
      let itemDiscount = item?.discount || 0;

      if (itemDiscountMethod == "%") {
        let discount = (itemDiscount / 100) * itemPrice;
        return formatNum((price - discount) * item.quantity);
      } else {
        return formatNum((price - itemDiscount) * item.quantity);
      }
    }
    return "-";
  };

  const usingMemo = useMemo(() => {
    const invQuantity = is_secondary_unit
      ? quantity / unit_conversion
      : quantity;
    const invType = type == "in" || type == "expense" ? "in" : "out";
    const profit =
      type == "expense" || type == "in"
        ? "-"
        : formatNum(
          ((item?.selling_price || 0) - (item?.cost_price || 0)) * quantity,
        );

    let chipTitle = table_name === INVOICE_SCHEMA ? (tran_type == 'cash' ? I18n.inout : tran_type == 'pos' ? I18n.sale_pos : I18n.invoice) : table_name === PAYMENT_SCHEMA ? 'Contacts' : ''

   
    return (
      <div className="invoiceListTableBody itemRportBody" key={key}>
        <ParagraphText className="ItemListTableBodyColumn justifyStart">
          <span className="truncate entryNameBox">
            {invType === "in"
              ? I18n.stock_in
              : invType === "out"
                ? I18n.stock_out
                : invType === "expense"
                  ? I18n.purchase
                  : I18n.sale}{" "}
            {refrence_id ? (
              <span className="newLightColor">{`(${chipTitle})`}</span>
            ) : null}
          </span>
        </ParagraphText>

        <ParagraphText className="ItemListTableBodyColumn justifyStart">
          {/* moment, not the English-only month helper, so Urdu gets its month name (shown right to left) */}
          {item?._raw?.transacted_at ? moment(item?._raw?.transacted_at).format("D MMM YYYY") : "-"}
        </ParagraphText>
        <ParagraphText className="ItemListTableBodyColumn justifyStart">
          {" "}
          {item?._raw?.transacted_at ? formatAMPM(item?._raw?.transacted_at) : "-"}
        </ParagraphText>
        <ParagraphText className="ItemListTableBodyColumn justifyStart">
          <span>
            {invType == "in" ? "+" : "-"}
            {is_secondary_unit ? (
              <span>
                {formatNum(quantity || 0)} {product.secondary_unit}
              </span>
            ) : (
              <span>
                {Math.floor(invQuantity * 100) / 100 || 0}{" "}
                {product?.unit || "Pieces"}
              </span>
            )}
          </span>
        </ParagraphText>
       
        <ParagraphText className="ItemListTableBodyColumn justifyEnd">
          Rs. {price || 0}{" "}
        </ParagraphText>
      </div>
    );
  }, [
    product.secondary_unit,
    is_secondary_unit,
    unit_conversion,
    product?.unit,
    transacted_at,
    tran_type,
    quantity,
    payment,
    invoice,
    txns,
    type,
    profit,
    price,
  ]);

  return usingMemo;
};

const enhance = withObservables(["item"], ({ item }) => ({
  item: item.observe(),
}));

export default enhance(StockHistoryTableRow);
